import './Theme.Card.Comment.scss';
export default 'ThemeCardComment';
